import { render, staticRenderFns } from "./BBadgeDropdown.vue?vue&type=template&id=12001563&"
import script from "./BBadgeDropdown.vue?vue&type=script&lang=js&"
export * from "./BBadgeDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BBadgeDropdown.vue?vue&type=style&index=0&id=12001563&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports